import { Company } from '@/models/company';
import { CreditResponse, CreditStatuses } from '@/services/api/models/credit';

/**
 * These are credit statuses used only by the client-side application.
 * It does not correspond to the API response.
 */
export enum InternalCreditStatus {
  SELECTED = 'selected', // credit is selected to be applied to an order
  APPLIED = 'applied', // credit is applied to an order locally, not yet submitted
  REMOVE = 'remove', // credit is marked as used, but to be removed from an order
}

/**
 * Company Credits to track the local status of each credit in MOv3, different from status:
 *  - available to use
 *  - selected to be used
 *  - applied to the order in UI
 */
export type InternalCreditStatuses = `${InternalCreditStatus}` | CreditStatuses;

export interface Credit extends CreditResponse {
  // Mutations add these properties
  displayName: string;
  internalStatus: InternalCreditStatuses;
}

/**
 * Company Credit Download Query
 */
export interface CreditDownloadQuery {
  brand?: number[];
  reason?: string[];
}

/**
 * Company Credit Downloads
 */
export interface CreditDownload {
  company: Company;
  query?: CreditDownloadQuery;
}
